import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";

export const SceneContainer = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  height: 100%;
  max-height: 125vh;
  canvas {
    cursor: grab;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      pointer-events: none;
    }
  }
`;

export const Scene = styled.div`
  width: 100vw;
  height: 125vh;
  overflow: hidden;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    height: 100vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 70vh;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: 60vh;
  }
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    height: 50vh;
  }

  @media screen and (width: 768px) and (height: 1024px),
    screen and (width: 1024px) and (height: 1366px),
    screen and (width: 820px) and (height: 1180px) {
    height: 50vh;
  }
`;

export const HeadingContainer = styled.div`
  ${props =>
    props.$absolute &&
    `${setPosition({ position: "absolute", top: "0", left: "0" })}`};

  height: 125vh;
  width: 100vw;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    height: 100vh;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 70vh;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    height: 60vh;
  }
  @media (max-width: ${BREAKPOINTS.xxs}px) {
    height: 50vh;
  }

  @media screen and (width: 768px) and (height: 1024px),
    screen and (width: 1024px) and (height: 1366px),
    screen and (width: 820px) and (height: 1180px) {
    height: 50vh;
  }
`;

export const BannerWrapper = styled.div`
  ${setPosition({ position: "absolute", zIndex: 3 })};
  min-height: auto;
  width: 100%;
`;

export const BannerContainer = styled.div`
  ${setFlex({ justify: "flex-start", align: "center" })};
  margin: 1rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    justify-content: center;
    margin: 1rem 0;
  }
`;

export const Item = styled.div`
  margin: 0 0.5rem;
`;

export const LogoWrapper = styled.div`
  padding-top: 1rem;
`;
